"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _connectToStores = _interopRequireDefault(require("fluxible-addons-react/connectToStores"));

var _page = require("@audacious/components/lib/components/page");

var _grid = require("@audacious/components/lib/components/grid");

var _client = require("@audacious/client");

var _simpleTable = _interopRequireDefault(require("@audacious/components/lib/components/table/simple/simple-table"));

var _text = _interopRequireDefault(require("@audacious/components/lib/components/text"));

var _button = _interopRequireDefault(require("@audacious/components/lib/components/button"));

var _iconButton = _interopRequireDefault(require("@audacious/components/lib/components/icon-button"));

var _popover = _interopRequireDefault(require("@audacious/components/lib/components/popover"));

var _alertMessage = _interopRequireDefault(require("@audacious/components/lib/components/alert-message"));

var _pageNotification = _interopRequireDefault(require("@audacious/components/lib/components/page-notification"));

var _date = _interopRequireDefault(require("@audacious/components/lib/formatters/date"));

var _checkInput = _interopRequireDefault(require("@audacious/components/lib/components/check-input"));

var _faExclamationCircle = require("@audacious/icons/regular/faExclamationCircle");

var _faArrowLeft = require("@audacious/icons/regular/faArrowLeft");

var _map = _interopRequireDefault(require("lodash/map"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _join = _interopRequireDefault(require("lodash/join"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _uploadPanelActions = require("../../../actions/uploadPanelActions");

var _patientPropType = _interopRequireDefault(require("../../../common/prop-types/patient-prop-type"));

require("./review-panels-page.css");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var COLUMNS = [{
  headerBody: 'Last Name',
  cellValuePath: 'patient.lastName',
  renderCell: function renderCell(cellValue) {
    return /*#__PURE__*/_react.default.createElement(_text.default, {
      size: "lg",
      weight: "semi-bold"
    }, cellValue);
  }
}, {
  headerBody: '',
  cellValuePath: 'issues',
  width: '64px',
  bold: true,
  renderCell: function renderCell(cellValue) {
    var issues = (0, _map.default)(cellValue, function (issue) {
      var path = issue.path,
          messages = issue.messages;
      var label = (0, _get.default)(issue, 'label', path);
      var messagesRender = (0, _map.default)(messages, function (message) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "message",
          key: message
        }, message);
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "path",
        key: path
      }, "".concat(label, ":")), messagesRender);
    });

    if (!(0, _isEmpty.default)(issues)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "issue-list"
      }, /*#__PURE__*/_react.default.createElement(_popover.default, {
        anchor: _iconButton.default,
        anchorProps: {
          icon: _faExclamationCircle.faExclamationCircle,
          color: 'danger',
          size: 'md'
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, issues)));
    }

    return null;
  }
}, {
  headerBody: 'First Name',
  cellValuePath: 'patient.firstName'
}, {
  headerBody: 'Middle Name',
  cellValuePath: 'patient.middleName'
}, {
  headerBody: 'DOB',
  cellValuePath: 'formatted.dob',
  width: '110px'
}, {
  headerBody: 'Gender',
  cellValuePath: 'formatted.gender',
  width: '100px'
}, {
  headerBody: 'Address',
  cellValuePath: ['patient.address1', 'patient.address2'],
  renderCell: function renderCell(cellValue) {
    var resultText = cellValue[1] ? "".concat(cellValue[0], ", ").concat(cellValue[1]) : cellValue[0];
    return resultText;
  }
}, {
  headerBody: 'City',
  cellValuePath: 'patient.city'
}, {
  headerBody: 'State',
  cellValuePath: 'patient.state',
  width: '80px'
}, {
  headerBody: 'Zip Code',
  cellValuePath: 'patient.zip',
  width: '100px'
}, {
  headerBody: 'Phone',
  cellValuePath: 'formatted.phone',
  width: '160px'
}];

function getNumberOfErroredItems(items) {
  return (0, _reduce.default)(items, function (acc, item) {
    if (item.issues && item.issues.length > 0) {
      return acc + 1;
    }

    return acc;
  }, 0);
}

var _ref =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_alertMessage.default, {
  color: "danger",
  icon: _faExclamationCircle.faExclamationCircle,
  message: "We are unable to complete your new panel at this time. Please try again at a later time.",
  size: "xs",
  className: "review-panel-upload-error-alert"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_page.PageTitle, {
  pageName: "Review Panel"
});

var ReviewPanelsPage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ReviewPanelsPage, _React$Component);

  var _super = _createSuper(ReviewPanelsPage);

  function ReviewPanelsPage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReviewPanelsPage);
    _this = _super.call(this, props);
    _this.handleSubmitClick = _this.handleSubmitClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancelClick = _this.handleCancelClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemoveErrors = _this.handleRemoveErrors.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemoveErrorsAlertClick = _this.handleRemoveErrorsAlertClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemoveErrorsAlertCancel = _this.handleRemoveErrorsAlertCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleReminderOkClick = _this.handleReminderOkClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleShouldDownloadLogChange = _this.handleShouldDownloadLogChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      showRemoveErrorsNotification: false,
      showRemoveErrorsReminder: false,
      shouldDownloadErrorLog: true
    };
    return _this;
  }

  (0, _createClass2.default)(ReviewPanelsPage, [{
    key: "handleSubmitClick",
    value: function handleSubmitClick() {
      var _this$props = this.props,
          importedPanel = _this$props.importedPanel,
          importedPanelFileName = _this$props.importedPanelFileName;
      var service = this.context.service;
      var numberOfErrorItems = getNumberOfErroredItems(importedPanel);

      if (numberOfErrorItems) {
        this.setState({
          showRemoveErrorsReminder: true
        });
      } else {
        service.missingPersons.uploadPanel({
          data: _objectSpread(_objectSpread({}, importedPanel), {}, {
            importedPanelFileName: importedPanelFileName
          })
        });
      }
    }
  }, {
    key: "handleCancelClick",
    value: function handleCancelClick() {
      var executeAction = this.context.executeAction;
      executeAction(_uploadPanelActions.cancelReviewPanel);
    }
  }, {
    key: "handleRemoveErrorsAlertClick",
    value: function handleRemoveErrorsAlertClick() {
      this.setState({
        showRemoveErrorsNotification: true
      });
    }
  }, {
    key: "handleRemoveErrors",
    value: function handleRemoveErrors() {
      var executeAction = this.context.executeAction;
      var _this$props2 = this.props,
          organizationName = _this$props2.organizationName,
          userName = _this$props2.userName,
          importedPanelFileName = _this$props2.importedPanelFileName,
          importedPanel = _this$props2.importedPanel;
      var shouldDownloadErrorLog = this.state.shouldDownloadErrorLog;

      if (shouldDownloadErrorLog) {
        var csvString = '';
        csvString += "User Name,".concat(userName, "\n");
        csvString += "Organization,".concat(organizationName, "\n");
        csvString += "Missing Persons File,".concat(importedPanelFileName, "\n");
        csvString += "Missing Persons Panel Date,".concat((0, _date.default)(new Date().toString(), {
          outFormat: 'MM/DD/YYYY h:mm a'
        }), "\n");
        csvString += '\n';
        var errorPatients = (0, _filter.default)(importedPanel, function (patient) {
          return patient.issues && patient.issues.length > 0;
        });
        var numberOfErrors = 0;
        (0, _forEach.default)(errorPatients, function (patient) {
          if (patient.issues.length > numberOfErrors) {
            numberOfErrors = patient.issues.length;
          }
        });
        csvString += 'First Name,Middle Name,Last Name,DOB,Gender,Address Line 1,Address Line 2,City,State,Zip Code,Country Code,Phone';

        for (var i = 0; i < numberOfErrors; i += 1) {
          csvString += ",Error ".concat(i + 1);
        }

        csvString += '\n';
        (0, _forEach.default)(errorPatients, function (patient) {
          csvString += "".concat((0, _get.default)(patient, 'patient.firstName', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.middleName', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.lastName', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.unalteredDob', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'formatted.gender', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.address1', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.address2', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.city', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.state', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.unalteredZipCode', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.unalteredCountryCode', '') || '');
          csvString += ",".concat((0, _get.default)(patient, 'patient.unalteredPhone', '') || '');
          var issues = patient.issues;
          (0, _forEach.default)(issues, function (issue) {
            var label = issue.label,
                messages = issue.messages;
            csvString += ",".concat(label, ": ").concat((0, _join.default)(messages, '; '));
          });
          csvString += '\n';
        });
        var link = document.createElement('a');
        link.href = "data:text/csv;charset=UTF-8,".concat(encodeURIComponent(csvString));
        link.download = 'imported-panel-error-log.csv';
        link.click();
      }

      executeAction(_uploadPanelActions.removeErrorPanelItems);
      this.setState({
        showRemoveErrorsNotification: false
      });
    }
  }, {
    key: "handleRemoveErrorsAlertCancel",
    value: function handleRemoveErrorsAlertCancel() {
      this.setState({
        showRemoveErrorsNotification: false
      });
    }
  }, {
    key: "handleReminderOkClick",
    value: function handleReminderOkClick() {
      this.setState({
        showRemoveErrorsReminder: false
      });
    }
  }, {
    key: "handleShouldDownloadLogChange",
    value: function handleShouldDownloadLogChange(value) {
      this.setState({
        shouldDownloadErrorLog: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          importedPanel = _this$props3.importedPanel,
          submitPanelHasError = _this$props3.submitPanelHasError;
      var _this$state = this.state,
          showRemoveErrorsNotification = _this$state.showRemoveErrorsNotification,
          showRemoveErrorsReminder = _this$state.showRemoveErrorsReminder,
          shouldDownloadErrorLog = _this$state.shouldDownloadErrorLog;
      var numberOfErrorItems = getNumberOfErroredItems(importedPanel);
      var totalItems = importedPanel ? importedPanel.length : 0;
      var invalidItemsAlert = numberOfErrorItems ? /*#__PURE__*/_react.default.createElement(_page.PageContainerGroup, null, /*#__PURE__*/_react.default.createElement(_alertMessage.default, {
        color: "danger",
        icon: _faExclamationCircle.faExclamationCircle,
        message: "To continue upload, please remove the error records (".concat(numberOfErrorItems, " of ").concat(totalItems, "). Or cancel the upload."),
        size: "xs",
        className: "review-panel-remove-alert",
        action: {
          label: 'Remove Error Records',
          onClick: this.handleRemoveErrorsAlertClick
        }
      })) : null;
      var removeErrorItemsNotification = showRemoveErrorsNotification ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_pageNotification.default, {
        blocking: true,
        actions: [{
          label: 'Remove',
          matchColor: true,
          onClick: this.handleRemoveErrors
        }, {
          label: 'Cancel',
          matchColor: true,
          onClick: this.handleRemoveErrorsAlertCancel
        }],
        color: "danger",
        heading: "Remove All Error Records",
        message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "Remove error (".concat(numberOfErrorItems, " of ").concat(totalItems, ") records from the panel.")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_checkInput.default, {
          id: "download-error-log-check-input",
          size: "sm",
          haloSize: "sm",
          label: "Download Error Log",
          value: shouldDownloadErrorLog,
          onChange: this.handleShouldDownloadLogChange
        }))),
        className: "missing-persons-error-remove-confirmation"
      })) : null;
      var removeErrorsReminder = showRemoveErrorsReminder ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_pageNotification.default, {
        actions: [{
          label: 'Okay',
          matchColor: false,
          onClick: this.handleReminderOkClick
        }],
        color: "danger",
        showIcon: true,
        blocking: true,
        heading: "Remove Error Records",
        message: "The Missing Persons panel can not contain any errors. Please remove error records or cancel the upload.",
        className: "missing-persons-error-remove-reminder"
      })) : null;
      var contentRender = null;

      if (submitPanelHasError) {
        contentRender = /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-error-container"
        }, _ref, /*#__PURE__*/_react.default.createElement("div", {
          className: "return-button"
        }, /*#__PURE__*/_react.default.createElement(_button.default, {
          color: "primary",
          variant: "opaque",
          id: "review-panel-error-back-button",
          onClick: this.handleCancelClick,
          leftIcon: _faArrowLeft.faArrowLeft
        }, "Back to Missing Persons")));
      } else {
        contentRender = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, invalidItemsAlert, /*#__PURE__*/_react.default.createElement(_simpleTable.default, {
          id: "review-panel-table",
          items: importedPanel,
          columns: COLUMNS,
          minWidth: 1200,
          alwaysShowHeaders: true,
          pageTable: true,
          useParentScroll: true
        }), /*#__PURE__*/_react.default.createElement(_page.PageContainerGroup, null, /*#__PURE__*/_react.default.createElement(_grid.Row, {
          gutter: {
            h: '16'
          },
          className: "button-row"
        }, /*#__PURE__*/_react.default.createElement(_grid.Column, {
          width: "content"
        }, /*#__PURE__*/_react.default.createElement(_button.default, {
          color: "primary",
          variant: "fill",
          id: "review-panel-submit-button",
          onClick: this.handleSubmitClick
        }, "Submit Panel")), /*#__PURE__*/_react.default.createElement(_grid.Column, {
          width: "content"
        }, /*#__PURE__*/_react.default.createElement(_button.default, {
          color: "primary",
          variant: "opaque",
          id: "review-panel-cancel-button",
          onClick: this.handleCancelClick
        }, "Cancel")))), removeErrorItemsNotification, removeErrorsReminder);
      }

      return /*#__PURE__*/_react.default.createElement(_client.AuthenticatedPage, {
        id: "review-panels-page",
        pageName: "Missing Persons",
        variant: "grey",
        hideTitle: true,
        hideFooter: true
      }, _ref2, /*#__PURE__*/_react.default.createElement(_page.PageContainer, {
        asCard: true,
        allowScroll: true,
        className: "page-main-content review-panels-content-container"
      }, contentRender));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return ReviewPanelsPage;
}(_react.default.Component);

ReviewPanelsPage.contextTypes = {
  executeAction: _propTypes.default.func.isRequired,
  service: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]))
};

var _default = (0, _connectToStores.default)(ReviewPanelsPage, ['MissingPersonsStore', 'Session'], function (context) {
  var missingPersonsStore = context.getStore('MissingPersonsStore');
  var importedPanel = missingPersonsStore.getImportedPanel();
  var submitPanelHasError = missingPersonsStore.getSubmitPanelHasError();
  var importedPanelFileName = missingPersonsStore.getImportedPanelFileName();
  var sessionStore = context.getStore('Session');
  var org = sessionStore.getOrganization();
  var user = sessionStore.getUser();
  var firstName = user.getFirstName();
  var lastName = user.getLastName();
  var userName = "".concat(firstName, " ").concat(lastName);
  return {
    importedPanel: importedPanel,
    submitPanelHasError: submitPanelHasError,
    organizationName: org.getName(),
    userName: userName,
    importedPanelFileName: importedPanelFileName
  };
});

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(COLUMNS, "COLUMNS", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/review-panels-page/review-panels-page.jsx");
  reactHotLoader.register(getNumberOfErroredItems, "getNumberOfErroredItems", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/review-panels-page/review-panels-page.jsx");
  reactHotLoader.register(ReviewPanelsPage, "ReviewPanelsPage", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/review-panels-page/review-panels-page.jsx");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/review-panels-page/review-panels-page.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();